<template>
  <div class="noticecomponent">



    <div class="tab-header">
      <span :class="[tabActive===0?'active':'']" @click="tabFun(0)">公告</span>
      <span :class="[tabActive===1?'active':'']" @click="tabFun(1)">简报</span>
    </div>

    <!-- 公告 -->
    <div class="tab-body" v-if="tabActive===0">
      <div class="content">
        <div class="item"><a class="item-hd" @click="sendValFun">[班级]太原赛事沟通群</a>
          <div class="item-bd">2025-05-14</div>
        </div>
      </div>
    </div>

    <!-- 简报 -->
    <div class="live-notyet" v-if="tabActive===1">
      <div class="nodata_bg_img"><img src="https://www.ttcdw.cn/p/uc/static/img/empty_bg.ebf669a.png">
        <p class="notyet-text">暂无内容</p>
      </div>
    </div>
  </div>
</template>


<script>
import communicationgroup from './communicationgroup.vue';
import noticecomponent from './noticecomponent.vue';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      tabActive: 0
    }
  },
  components: {
    communicationgroup,
    noticecomponent
  },
  created() {

  },
  mounted() {
    document.title = '山西省第四届家庭教育指导技能大赛报名'
  },
  computed: {

  },
  methods: {
    ...mapMutations("singup", ["SET_Tab",]),
    toPage(page) {
      this.$router.push(page)
    },
    tabFun(index) {
      this.tabActive = index
    },
    sendValFun() {
      this.SET_Tab(true)
    }
  },

}
</script>
<style lang="scss" scoped>
.noticecomponent {
  width: 100%;
  height: 100%;

  .tab-header {
    padding: 15px 30px;
    border-bottom: 1px solid #d9d9d9;
    box-shadow: 0 1px 0 #f2f2f2;

    span.active {
      color: #3b70ff;
    }

    span {
      padding: 0 10px;
      color: #666;
      font-size: 16px;
      display: inline-block;
      line-height: 40px;
      margin: 0 20px 0 0;
      cursor: pointer;
    }

    span:hover {
      color: #3b70ff;
    }
  }

  .tab-body {
    margin: 30px 0 0 0;
    padding: 0 40px 40px 40px;

    .content {
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0 30px 0;

        .item-hd {
          color: #666;
          font-size: 14px;
          cursor: pointer;

          &:hover {
            color: #3b70ff;
          }
        }

        .item-bd {
          color: #666;
          font-size: 14px;
        }
      }
    }
  }

  .live-notyet {
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;

    .nodata_bg_img {
      img {
        width: 350px;
      }

      .notyet-text {
        font-size: 16px;
        color: #999999;
        line-height: 22px;
        font-weight: 500;
        color: #333333;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
      }
    }
  }

}
</style>
